export default class CourseSchedule {
}
